import { getObjectUtil } from 'packages/src'
import { WORKOUT_EXERCISE_KEY } from '../../../../workout-exercise/model'
import { SET_DATA_KEY } from '../../../../workout-exercise/model/constants'

import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import updateWorkoutExerciseAction from '../../../../workout-exercise/redux/actions/update'
import WORKOUT_EXERCISES_PATH from '../../../../workout-exercise/redux/constants/path'
import { updateCurrentRoundIndexWorkoutExerciseAction } from '../update-current-round-index'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import getCircuitCurrentRoundIndexWorkoutSectionSelect from '../../selectors/get-circuit-current-round-index'
import { getCurrentRoundWorkoutSectionSelector } from '../../selectors/get-current-round'
import updateDataWorkoutAction from '../../../../workout/redux/actions/update-data'

function deleteRoundWorkoutSectionAction () {
  return (dispatch, getState) => {
    const round = getCurrentRoundWorkoutSectionSelector()(getState())
    const updates = []
    const currentRoundIndex = getCircuitCurrentRoundIndexWorkoutSectionSelect(
      getState())
    const workoutExercisesDomainMap = getObjectUtil(getState(),
      WORKOUT_EXERCISES_PATH.DATA
    )

    if (!round) {
      return
    }

    const workoutExerciseIdToSetData = {}
    const workoutExercisesToUpdate = []
    round.forEach((roundSet) => {
      if (roundSet[SET_DATA_KEY.REST]) {
        return
      }

      const workoutExerciseId = roundSet.workoutExerciseId
      const workoutExercise = workoutExercisesDomainMap[workoutExerciseId]
      let setData = (
        workoutExerciseIdToSetData[workoutExerciseId] ||
        getValueReduxUtil(workoutExercise,
          WORKOUT_EXERCISE_KEY.SET_DATA)
      )

      const setsToRemove = [roundSet.set]

      setData = setData.filter(set => {
        return !setsToRemove.find(setToRemove => setToRemove === set)
      })

      updates.push({ setData })
      workoutExercisesToUpdate.push(workoutExercise)
      workoutExerciseIdToSetData[workoutExerciseId] = setData
    })

    workoutExercisesToUpdate.forEach((workoutExerciseToUpdate, index) => {
      dispatch(updateWorkoutExerciseAction({
        type: WORKOUT_SECTIONS_ACTION.DELETE_ROUND,
        payload: {
          workoutExercise: workoutExerciseToUpdate,
          updates: updates[index]
        }
      }))
    })

    if (currentRoundIndex) {
      dispatch(updateCurrentRoundIndexWorkoutExerciseAction(currentRoundIndex -
        1))
    }
    dispatch(updateDataWorkoutAction())
  }
}

export { deleteRoundWorkoutSectionAction }
